// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"53244918","239":"bebfd7a7","455":"c864645a"}[chunkId] + ".chunk.js";
};